
























import { Component, Prop, Vue } from 'vue-property-decorator';

@Component({})
export default class LinkRow extends Vue {
	@Prop({ required: true, type: String })
	public href!: string;

	@Prop({ required: true, type: String })
	public title!: string;

	@Prop({ required: false })
	public value?: string | number | null;

    @Prop({ required: false, type: String, default: "_blank" })
	public target!: string;

	@Prop({ required: false, type: String })
	public tooltip?: string | null;

	@Prop({ required: false, type: Boolean, default: false })
	public warn!: boolean;
}
